/* eslint-disable jsx-a11y/anchor-is-valid */
import { DownOutlined, LoadingOutlined } from '@ant-design/icons';
import type { MenuProps } from 'antd';
import { Button, Dropdown, Modal, Space, Spin } from 'antd';
import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { TOKEN_LOCAL_STORAGE_KEY } from '../const/app';
import { ROUTES } from '../const/routes';
import { useActiveSchoolId } from '../hooks/useActiveSchoolId';
import { useUser } from '../hooks/useUser';
import { useUserStore } from '../stores/UserStore';
import { trpc } from '../utils/trcp';
import { SchoolSwitch } from './SchoolSwitch/SchoolSwitch';

const items: MenuProps['items'] = [
	{
		key: '1',
		label: (
			<Link
				to="#"
				onClick={() => {
					localStorage.removeItem(TOKEN_LOCAL_STORAGE_KEY);
					window.location.href = ROUTES.OUT_APP.LOGIN;
				}}
			>
				Odhlásit se
			</Link>
		),
	},
];

const UserMenu: React.FC = () => {
	const schools = useUserStore(state => state.schools);
	const setActiveSchoolIdTrpc = trpc.user.setActiveSchoolId.useMutation();

	const { activeSchoolId, setActiveSchoolId } = useActiveSchoolId();

	const setActiveSchool = async (schoolId: string) => {
		setActiveSchoolId(schoolId);
		await setActiveSchoolIdTrpc.mutateAsync({ schoolId });
	};
	const user = useUser();

	const [isModalOpen, setIsModalOpen] = useState(false);

	const handleOk = () => {
		setIsModalOpen(false);
	};

	const handleCancel = () => {
		setIsModalOpen(false);
	};

	if (schools.length === 0) {
		return (
			<div>
				<Spin indicator={<LoadingOutlined style={{ fontSize: 15 }} spin />} />
			</div>
		);
	}

	if (schools.length > 1) {
		return (
			<>
				<Space direction="horizontal" size="large">
					<SchoolSwitch />
					<Dropdown menu={{ items }}>
						<span onClick={e => e.preventDefault()}>
							<Space>
								{user?.email}
								<DownOutlined />
							</Space>
						</span>
					</Dropdown>
				</Space>
				<Modal
					title="Vyberte autoškolu, kterou chcete spravovat"
					open={isModalOpen}
					onOk={handleOk}
					onCancel={handleCancel}
				>
					<Space direction="vertical">
						{schools?.map(school => (
							<Button
								onClick={() => setActiveSchool(school.id)}
								key={school.id}
								type={school.id === activeSchoolId ? 'primary' : undefined}
							>
								{school.name}
							</Button>
						))}
					</Space>
				</Modal>
			</>
		);
	}

	return (
		<div>
			<Dropdown menu={{ items }}>
				<span onClick={e => e.preventDefault()}>
					<Space>
						{user.email}
						<DownOutlined />
					</Space>
				</span>
			</Dropdown>
		</div>
	);
};

export default UserMenu;
